import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-xero-reauthorize-modal',
  templateUrl: './xero-reauthorize-modal.component.html',
  styleUrls: ['./xero-reauthorize-modal.component.css'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule]
})
export class XeroReauthorizeModalComponent implements OnInit, OnDestroy {
  isAuthorizing = false;
  authorizationComplete = false;
  authWindow: Window | null = null;
  checkInterval: any;

  constructor(public dialogRef: MatDialogRef<XeroReauthorizeModalComponent>, private http: HttpClient) {}

  ngOnInit(): void {
    // Listen for messages from the authorization window
    window.addEventListener('message', this.onMessageReceived.bind(this));
  }

  ngOnDestroy(): void {
    // Clean up
    window.removeEventListener('message', this.onMessageReceived.bind(this));
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    if (this.authWindow && !this.authWindow.closed) {
      this.authWindow.close();
    }
  }

  startXeroAuthorization(): void {
    this.isAuthorizing = true;
    
    // Get the proper authorization URL from the backend
    this.http.get<any>('/charitycentral/xeroreauthorize/getAuthorizationUrl').subscribe({
      next: (response) => {
        const authUrl = response.authorizationUrl;
        
        // Open Xero authorization window with the proper URL
        this.authWindow = window.open(authUrl, 'XeroAuth', 'width=600,height=700,menubar=no,toolbar=no,scrollbars=yes');

        // Poll to check if window was closed
        this.checkInterval = setInterval(() => {
          if (this.authWindow && this.authWindow.closed && !this.authorizationComplete) {
            this.isAuthorizing = false;
            clearInterval(this.checkInterval);
          }
        }, 1000);
      },
      error: (error) => {
        this.isAuthorizing = false;
        console.error('Error getting authorization URL:', error);
      }
    });
  }

  private onMessageReceived(event: MessageEvent): void {
    // Verify the message comes from our authorization window
    if (event.origin !== window.location.origin) {
      return;
    }

    // Check if authorization was successful
    if (event.data === 'xero-auth-complete') {
      this.completeAuthorization();
    }
  }

  // Manual button to confirm authorization is complete
  confirmAuthorizationComplete(): void {
    this.completeAuthorization();
  }

  private completeAuthorization(): void {
    this.authorizationComplete = true;
    this.isAuthorizing = false;
    
    if (this.authWindow && !this.authWindow.closed) {
      this.authWindow.close();
    }

    // Close the modal after a brief delay to show success state
    setTimeout(() => {
      this.dialogRef.close(true);
    }, 1500);
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}
